export const isTokenExpired = () => {
  const token = localStorage.getItem('avalia-token')

  if (!token) return true

  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    return payload.exp <= Math.floor(Date.now() / 1000)
  } catch {
    return true
  }
}
